import React, { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import AbstractTable from 'common/AbstractTable/StyledTable'
import { format, parseISO } from 'date-fns'
import PropTypes from 'prop-types'

import TabPanel from '../../../../../../common/TabPanel/TabPanel'
import { ColorBoxContent } from '../../../../../../common/ui/colorBox'
import { OrderChangeState } from '../../../../../../types/order.type'
import OrderDetails from '../../../../SharedComponents/OrderDetails'

import statusHistoryColDefs from './columnDefs'
import OrderDeliveryMap from './OrderDeliveryMap'
import ProvisionedItemsDetails from './ProvisionedItemsDetails'

/** @type {Object.<string, import('@mui/styled-engine').CSSProperties>} */
const classes = {
  '& .MuiTab-root': {
    textTransform: 'initial',
    fontWeight: '600',
    fontSize: '16px',
    color: 'black'
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: 'blue',
    color: 'white'
  },
  '& .MuiTab-root.Mui-selected:first-of-type': {
    borderRadius: '8px 0px 0px 0px'
  }
}

/**
 * @param {Object} props
 * @param {import('../../../../../../types/order.type').OrderModel} props.order
 * @param {import('../../../../../../types/provision.type').ProvisioningStatus} props.provisionedItems
 */
function OrderStateTabView(props) {
  const { order, provisionedItems } = props

  const [tabValue, setTabValue] = useState(0)
  const handleTabChange = (_, newNum) => {
    setTabValue(newNum)
  }

  /** @type {import('../../../../../../types/order.type').OrderModel['statusHistory']} */
  const historyData = [
    ...order.statusHistory,
    {
      status: order.status,
      triggeringAction: '---',
      statusSetAt: order.updatedAt
    }
  ].map((v) => ({
    ...v,
    statusSetAt: format(parseISO(v.statusSetAt), 'dd-MM-yyyy HH:mm')
  }))

  const shouldShowProvisionedItems = [
    OrderChangeState.READY_FOR_DELIVERY,
    OrderChangeState.SCHEDULED_FOR_DELIVERY,
    OrderChangeState.DELIVERY_IN_PROGRESS,
    OrderChangeState.DELIVERED
  ].includes(order.status)
  const shouldShowDelivery = [
    OrderChangeState.SCHEDULED_FOR_DELIVERY,
    OrderChangeState.DELIVERY_IN_PROGRESS,
    OrderChangeState.DELIVERED
  ].includes(order.status)

  return (
    <>
      <Box sx={{ bgcolor: '#ECEFF4', borderRadius: '8px 8px 0px 0px' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          TabIndicatorProps={{
            style: { display: 'none' }
          }}
          sx={classes}
        >
          <Tab label='Order Details' value={0} />
          <Tab label='Provisioned Items' value={1} />
          <Tab label='Status History' value={2} />
          <Tab label='Delivery Details' value={3} />
        </Tabs>
      </Box>

      <ColorBoxContent style={{ borderRadius: '0px 0px 8px 8px' }}>
        <TabPanel value={tabValue} index={0}>
          <OrderDetails order={order} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <ProvisionedItemsDetails
            provisionedItems={provisionedItems}
            hasValidState={shouldShowProvisionedItems}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <AbstractTable
            data={historyData}
            header={null}
            name='view-one-order-order-history'
            columnDefs={statusHistoryColDefs}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <OrderDeliveryMap order={order} hasValidState={shouldShowDelivery} />
        </TabPanel>
      </ColorBoxContent>
    </>
  )
}

OrderStateTabView.propTypes = {
  order: PropTypes.object,
  provisionedItems: PropTypes.array
}

export default OrderStateTabView
